export const LANGUAGES = [
    { id: 'en', label: 'English', flag: '🇬🇧', htmlLang: 'en', ogLocale: 'en_US' },
    { id: 'zh', label: 'Chinese', flag: '🇨🇳', htmlLang: 'zh', ogLocale: 'zh_CN' },
    { id: 'th', label: 'Thai', flag: '🇹🇭', htmlLang: 'th', ogLocale: 'th_TH' },
    { id: 'vi', label: 'Viet', flag: '🇻🇳', htmlLang: 'vi', ogLocale: 'vi_VN' },
    { id: 'ja', label: 'Japan', flag: '🇯🇵', htmlLang: 'ja', ogLocale: 'ja_JP' },
    { id: 'ko', label: 'Korea', flag: '🇰🇷', htmlLang: 'ko', ogLocale: 'ko_KR' },
    { id: 'id', label: 'Indonesia', flag: '🇮🇩', htmlLang: 'id', ogLocale: 'id_ID' },
];
